var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    fill: "none",
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15.4367 17.9866H15.4112H7.85333L3 52.0755H51.5333L46.68 17.9866H39.0967V25.2666H34.85V17.9866H20.8842H19.6833V25.2666H15.4367V17.9866Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.2668 1.30322C33.6678 1.30322 38.9161 6.44311 39.0922 12.8032L39.0968 13.1332V17.9866H34.8501V13.1332C34.8501 8.96724 31.4327 5.54989 27.2668 5.54989C23.1934 5.54989 19.8357 8.81705 19.6885 12.8566L19.6834 13.1332V17.9866H15.4368V13.1332C15.4368 6.62187 20.7554 1.30322 27.2668 1.30322Z",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopper);
export default __webpack_public_path__ + "static/media/shopper.2804f26ca8a5c9b191362b9909e196f1.svg";
export { ForwardRef as ReactComponent };